window.onload = function () {
    var x;
    var $cards = $(".b_4 .card");
    var $style = $(".hover");
    var $b_4_wrap = $(".b_4_wrap .inner .card");

    function handleCardEffect(e) {
        var pos = [e.offsetX, e.offsetY];
        e.preventDefault();
        if (e.type === "touchmove") {
            pos = [e.touches[0].clientX, e.touches[0].clientY];
        }

        $cards.each(function () {
            var $card = $(this);
            var l = pos[0];
            var t = pos[1];
            var h = $card.height();
            var w = $card.width();
            var px = Math.abs(Math.floor(100 / w * l) - 100);
            var py = Math.abs(Math.floor(100 / h * t) - 100);
            var pa = (50 - px) + (50 - py);

            var lp = (50 + (px - 50) / 1.5);
            var tp = (50 + (py - 50) / 1.5);
            var px_spark = (50 + (px - 50) / 7);
            var py_spark = (50 + (py - 50) / 7);
            var p_opc = 20 + (Math.abs(pa) * 1.5);
            var ty = ((tp - 50) / 2) * -1;
            var tx = ((lp - 50) / 1.5) * .5;

            var grad_pos = `background-position: ${lp}% ${tp}%;`;
            var sprk_pos = `background-position: ${px_spark}% ${py_spark}%;`;
            var opc = `opacity: ${p_opc / 100};`;
            var tf = `transform: rotateX(${ty}deg) rotateY(${tx}deg)`;

            var style = `
                .card.active:before { ${grad_pos} }
                .card.active:after { ${sprk_pos} ${opc} }
            `;

            $cards.addClass("active");
            $card.removeClass("animated");
            $card.attr("style", tf);
            $style.html(style);
        });

        clearTimeout(x);
    }

    function resetCardEffect() {
        $cards.removeClass("active");
        $style.html("");
        $cards.removeAttr("style");
        x = setTimeout(function () {
            $cards.addClass("animated");
        }, 2500);
    }

    $b_4_wrap.on("mouseenter", function (e) {
        handleCardEffect(e);
    });

    $b_4_wrap.on("mousemove touchmove", function (e) {
        handleCardEffect(e);
    });

    $b_4_wrap.on("mouseleave touchend touchcancel", function () {
        resetCardEffect();
    });
};


$(document).ready(function () {
    const { Engine, Render, Runner, World, Bodies, Mouse, MouseConstraint, Query, Body } = Matter;
    const engine = Engine.create();
    const world = engine.world;
    const container = document.getElementById('physics-box');
    
    // ✅ PC에서만 오른쪽으로 그래비티 적용
    if (window.innerWidth > 1024) {
        engine.world.gravity.x = 0.3; // 오른쪽으로 살짝 힘을 줌
    } else {
        engine.world.gravity.x = 0; // 모바일에서는 X축 그래비티 비활성화
    }

    const render = Render.create({
        element: container,
        engine: engine,
        options: {
            width: container.offsetWidth,
            height: container.offsetHeight,
            wireframes: false,
            showBounds: false,
            background: 'var(--wc)'
        }
    });

    let imageUrls = [
        '//ecimg.cafe24img.com/pg326b45779995089/oiad/web/oiad_renewal/brand/i-1.png',
        '//ecimg.cafe24img.com/pg326b45779995089/oiad/web/oiad_renewal/brand/i-2.png',
        '//ecimg.cafe24img.com/pg326b45779995089/oiad/web/oiad_renewal/brand/i-3.png',
        '//ecimg.cafe24img.com/pg326b45779995089/oiad/web/oiad_renewal/brand/i-3.png',
        '//ecimg.cafe24img.com/pg326b45779995089/oiad/web/oiad_renewal/brand/i-3.png',
        '//ecimg.cafe24img.com/pg326b45779995089/oiad/web/oiad_renewal/brand/i-3.png',
        '//ecimg.cafe24img.com/pg326b45779995089/oiad/web/oiad_renewal/brand/i-3.png',
        '//ecimg.cafe24img.com/pg326b45779995089/oiad/web/oiad_renewal/brand/i-4.png',
        '//ecimg.cafe24img.com/pg326b45779995089/oiad/web/oiad_renewal/brand/i-5.png',
        '//ecimg.cafe24img.com/pg326b45779995089/oiad/web/oiad_renewal/brand/i-5.png',
        '//ecimg.cafe24img.com/pg326b45779995089/oiad/web/oiad_renewal/brand/i-6.png',
        '//ecimg.cafe24img.com/pg326b45779995089/oiad/web/oiad_renewal/brand/i-6.png',
        '//ecimg.cafe24img.com/pg326b45779995089/oiad/web/oiad_renewal/brand/i-7.png',
        '//ecimg.cafe24img.com/pg326b45779995089/oiad/web/oiad_renewal/brand/i-7.png',
        '//ecimg.cafe24img.com/pg326b45779995089/oiad/web/oiad_renewal/brand/i-8.png',
        '//ecimg.cafe24img.com/pg326b45779995089/oiad/web/oiad_renewal/brand/i-9.png',
        '//ecimg.cafe24img.com/pg326b45779995089/oiad/web/oiad_renewal/brand/i-9.png',
    ];

    let bodies = [];
    let isTriggered = false;

    function createImageBody(url) {
        const img = new Image();
        img.src = url;
        img.onload = function () {
            let originalWidth = img.naturalWidth;
            let originalHeight = img.naturalHeight;

            let scale = window.innerWidth <= 1024 ? 1 / 2 : 1;
            let width = originalWidth * scale;
            let height = originalHeight * scale;

            let x, y;
            let attempts = 0;
            let overlap = false;

            do {
                x = Math.random() * container.offsetWidth;
                y = -height;
                overlap = Query.region(world.bodies, {
                    min: { x: x - width / 2, y: y - height / 2 },
                    max: { x: x + width / 2, y: y + height / 2 }
                }).length > 0;
                attempts++;
            } while (overlap && attempts < 100);

            const body = Bodies.rectangle(x, y, width, height, {
                angle: Math.random() * Math.PI * 2,
                angularVelocity: (Math.random() - 0.5) * 0.1,
                render: {
                    sprite: {
                        texture: url,
                        xScale: scale,
                        yScale: scale
                    }
                },
                //mass: 1, //무게
                restitution: .6, // 반동 설정 (바운스 효과)
                friction: 0.02, // 물체가 바닥에서 미끄러지지만 아주 조금 저항이 있음.
                frictionAir: 0.04, // 공기 저항이 조금 있음, 자유 낙하 속도가 자연스럽게 조절됨.
            });

            // 🔹 블록이 생성될 때 오른쪽 방향으로 힘을 추가
            Body.applyForce(body, { x: body.position.x, y: body.position.y }, { x: 0.02, y: 0 });

            bodies.push(body);
            World.add(world, body);
        };
    }

    function dropBlocks() {
        if (!isTriggered) {
            isTriggered = true;
            imageUrls.forEach(url => createImageBody(url));
        }
    }

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                dropBlocks();
            }
        });
    }, { threshold: 0.5 });

    const targetElement = document.querySelector('.b_4 .cate_inner');
    if (targetElement) {
        observer.observe(targetElement);
    }

    const mouse = Mouse.create(render.canvas);
    const mouseConstraint = MouseConstraint.create(engine, {
        mouse: mouse,
        constraint: {
            stiffness: 0.2,
            render: { visible: false }
        }
    });
    World.add(world, mouseConstraint);
    render.mouse = mouse;

    const wallThickness = 1000;
    const walls = [
        Bodies.rectangle(container.offsetWidth / 2, -wallThickness / 2, container.offsetWidth + wallThickness * 2, wallThickness, { isStatic: true }),
        Bodies.rectangle(container.offsetWidth / 2, container.offsetHeight + wallThickness / 2, container.offsetWidth + wallThickness * 2, wallThickness, { isStatic: true }),
        Bodies.rectangle(-wallThickness / 2, container.offsetHeight / 2, wallThickness, container.offsetHeight + wallThickness * 2, { isStatic: true }),
        Bodies.rectangle(container.offsetWidth + wallThickness / 2, container.offsetHeight / 2, wallThickness, container.offsetHeight + wallThickness * 2, { isStatic: true })
    ];
    World.add(world, walls);

    Engine.run(engine);
    Render.run(render);

    const runner = Runner.create();
    Runner.run(runner, engine);

});

